import React, { useEffect, useState } from 'react';

import { Row, Col } from 'react-bootstrap';
import { Input, SwitchOption, Select, Text } from 'v3/components';
import Editable from 'v3/pages/CostCenter/shared/Editable';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';

import { usePermission } from 'hooks';

import { Divider } from '@mui/material';

function CardCostCenter({
  costCenter,
  fetchCostCenters,
  setEditMode,
  editMode,
  setSelectCostCenter
}) {

  const hasPermissionToEditCostCenter = usePermission('EDITAR_CENTRO_CUSTO');
  const snackbar = useSnackbar();

  const [active, setActive] = useState(!costCenter?.deletedAt);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const [selectOptions, setSelectOptions] = useState([
    { name: 'Não', id: 0 },
    { name: 'Sim', id: 1 },
  ]);

  useEffect(() => {
    if (costCenter?.deletedAt) {
      setActive(false);
    } else setActive(true);

    setData({
      ...costCenter,
      limitSchedule: costCenter?.limitSchedule ? selectOptions[1] : selectOptions[0],
      showLoadingOrder: costCenter?.showLoadingOrder ? selectOptions[1] : selectOptions[0],
      travelWithoutExternalId: costCenter?.travelWithoutExternalId ? selectOptions[1] : selectOptions[0],
      travelSplitDelivery: costCenter?.travelSplitDelivery ? selectOptions[1] : selectOptions[0],
      linkChecklistIntegrationTravel: costCenter?.linkChecklistIntegrationTravel ? selectOptions[1] : selectOptions[0],
    });
  }, [costCenter]);


  async function handleUpdate() {
    setLoading(true);

    try {
      const response = await cooperplaceApi.put(`/cost-center/${costCenter.id}`, {
        showLoadingOrder: data.showLoadingOrder?.id,
        travelWithoutExternalId: data.travelWithoutExternalId?.id,
        travelSplitDelivery: data.travelSplitDelivery?.id,
        limitSchedule: data.limitSchedule?.id,
        linkChecklistIntegrationTravel: data.linkChecklistIntegrationTravel?.id,
      });

      setSelectCostCenter(response.data);
      await fetchCostCenters();

      snackbar.show(<Text>Atualizado com sucesso</Text>, { type: 'success' });

      setEditMode(false);
    } catch (error) {
      snackbar.show(<Text>Erro ao atualizar</Text>, { type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Col md={7} xl={7} className="ml-2">
        <Row style={{
          marginTop: '20px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Col md={3} xl={3}>
            <Text
              fontSize={23}
              color={'#494950b4'}
              weight={600}>
              Dados Gerais
            </Text>
          </Col>
          <Col md={6} xl={6} style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            {
              data?.lastLevel && (
                <Editable
                  isEditing={editMode}
                  setEditing={setEditMode}
                  hasPermissionToEditCostCenter={hasPermissionToEditCostCenter}
                  onSave={handleUpdate}
                  isLoading={loading}
                  costCenter={costCenter}
                  setData={setData}
                  selectOptions={selectOptions}
                />
              )
            }
          </Col>
        </Row>
        <Col xs={12} md={12} className='mt-3'>
          <SwitchOption
            disabled={true}
            value={active}
          />
        </Col>
        <Row>
          <Col xs={6} md={6} className="mt-3">
            <Input
              label="Nome"
              disabled={true}
              value={data?.name}
              labelSize="0.9rem"
            />
          </Col>
          <Col xs={6} md={6} className="mt-3">
            <Input
              label="Codigo"
              disabled={true}
              value={data?.identifier}
              labelSize="0.9rem"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={6} className="mt-3">
            <Input
              label="Empresa"
              disabled={true}
              value={data?.enterprise?.name}
              labelSize="0.9rem"
            />
          </Col>
          <Col xs={6} md={6} className="mt-3">
            <Input
              label="Ultimo Nivel"
              disabled={true}
              value={data?.lastLevel ? 'Sim' : 'Não'}
              labelSize="0.9rem"
            />
          </Col>
        </Row>
        {
          data?.lastLevel && (
            <Row xs={12} md={12}>
              <Col xs={6} md={6} className="mt-3">
                <Select
                  label={'Limite de Agendamento'}
                  labelSize={'0.9rem'}
                  options={selectOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.limitSchedule}
                  placeholder={null}
                  onChange={value => {
                    setData({ ...data, limitSchedule: value });
                  }}
                  isDisabled={!editMode}
                  tooltip='Permite atender a carga com data de coleta retroativa'
                />
              </Col>
              <Col xs={6} md={6} className="mt-3">
                <Select
                  label={'Mostrar Ordem de Carregamento'}
                  labelSize={'0.9rem'}
                  options={selectOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.showLoadingOrder}
                  placeholder={null}
                  onChange={value => {
                    setData({ ...data, showLoadingOrder: value });
                  }}
                  isDisabled={!editMode}
                  tooltip='Permitir visualizar a "ordem de carregamento" quando a viagem está no status "ordem de coleta'
                />
              </Col>
              <Col xs={6} md={6} className="mt-3">
                <Select
                  label={'Permitir iniciar viagem sem documentos logísticos'}
                  labelSize={'0.9rem'}
                  options={selectOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.travelWithoutExternalId}
                  placeholder={null}
                  onChange={value => {
                    setData({ ...data, travelWithoutExternalId: value });
                  }}
                  isDisabled={!editMode}
                  tooltip={`
                      a) Origem exterior: permitir alterar do status "Carregamento finalizado" para SOMENTE os seguintes status: "Em viagem", "Cancelado", "Transbordo"\n
                      b) Origem nacional: permitir alterar além dos status normais o status "Em viagem"
                    `}

                />
              </Col>
              <Col xs={6} md={6} className="mt-3">
                <Select
                  label={'Entregas Fracionadas'}
                  labelSize={'0.9rem'}
                  options={selectOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.travelSplitDelivery}
                  placeholder={null}
                  onChange={value => {
                    setData({ ...data, travelSplitDelivery: value });
                  }}
                  isDisabled={!editMode}
                  tooltip={`
                Sim - Permite o usuário informar aleatoriamente nas entregas a chegada e efetivado.\n
                Não - Segue regra de 500 metros para informar no carregamento a entregas a chegada e efetivado.
              `}
                />
              </Col>
              <Col xs={6} md={6} className="mt-3">
                <Select
                  label={'Vincular checklist nas viagem de integração'}
                  labelSize={'0.9rem'}
                  options={selectOptions}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  value={data?.linkChecklistIntegrationTravel}
                  placeholder={null}
                  onChange={value => {
                    setData({ ...data, linkChecklistIntegrationTravel: value });

                  }}
                  isDisabled={!editMode}
                  tooltip={`
                Sim - Permite vincular checklist nas viagens que são criadas a partir de integração de forma automática caso haja checklist correspondente para aquela viagem.\n
                Não - Não Permite vincular checklist nas viagens que são criadas a partir de integração de forma automática caso haja checklist correspondente para aquela viagem.
              `}
                />
              </Col>
            </Row>
          )
        }
        <Divider
          flexItem
          sx={{ width: 'auto', backgroundColor: '#e0e0e0', height: '2px', marginY: '16px' }}
        />
        <Col xs={12} md={12} style={{ display: 'flex', flexDirection: 'column', gap: '3px' }} className="mt-2">
          <Text
            fontSize={16}
            color={'#494950b4'}
            weight={600}
          >
            Nivel: {costCenter?.level}
          </Text>
          <Text
            fontSize={16}
            color={'#494950b4'}
            weight={600}
          >
            Estrutura: {costCenter?.structure}
          </Text>
        </Col>
      </Col>
    </>
  );
}

export default CardCostCenter;
